/**
  @param endpoints (Array of endpoints)
  @param types (Array of types)
  @param id (String of GoNation ID's)
**/
export default (function (endpoints, types, ID) {
  if (endpoints === void 0) {
    endpoints = [];
  }
  if (types === void 0) {
    types = [];
  }
  if (ID === void 0) {
    ID = '';
  }
  return endpoints.filter(_ref => {
    let {
      node
    } = _ref;
    return types.filter(type => type === node.data.type).length;
  }).map(_ref2 => {
    let {
      node
    } = _ref2;
    return {
      type: replaceParams(node.data.type, ID),
      url: replaceParams(node.data.url, ID)
    };
  });
});
const replaceParams = (txt, ID) => txt.replace('{GONATION_ID}', ID);